import React from 'react';
import { PlusIcon } from 'lucide-react';
import type { ServiceFaq } from '../../types/servicePage';
type ServiceFaqsProps = {
  faqs: ServiceFaq[];
};
export function ServiceFaqs({
  faqs
}: ServiceFaqsProps) {
  return <section className="bg-white py-20 lg:py-24" data-id="element-381" data-mp="grpqja5tahip">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-[0.75fr_1.25fr] lg:gap-16 lg:px-8" data-id="element-382" data-mp="cr5r1zxrn1te">
        <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] text-ink sm:text-5xl" data-id="element-383" data-mp="3l6z4u70ppz6r">
          Common <span className="text-brand" data-id="element-384" data-mp="3g8fja7q16pex">questions</span>
        </h2>
        <div className="divide-y divide-line border-y border-line" data-id="element-385" data-mp="3ga8rvsk7fjpk">
          {faqs.map(f => <details key={f.q} className="group py-5" data-id="element-386" data-mp="3u5awmcdbf30s">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-display text-2xl font-bold text-ink [&::-webkit-details-marker]:hidden" data-id="element-387" data-mp="3p7svh85jhs3c">
                {f.q}
                <PlusIcon className="h-5 w-5 shrink-0 text-brand transition-transform duration-150 group-open:rotate-45" aria-hidden="true" data-id="element-388" data-mp="14hjybdb9xfw3" />
              </summary>
              <p className="mt-3 text-lg leading-relaxed text-ink-muted" data-id="element-389" data-mp="vn6s6ysz96fk">{f.a}</p>
            </details>)}
        </div>
      </div>
    </section>;
}